<template>
  <div class="vehicles" :class="{'is__action' : hasAction}" v-if="vehicles.count > 0">

    <div v-for="(vehicle, index) in vehicles.data" :key="(vehicle.id + index)">
      <div class="vehicle c">


        <div class="images vehicleImage">
          <carousel :scrollPerPage="false" :perPage="1" :paginationEnabled="false" :navigationEnabled="true"

                    :navigationNextLabel="nextLabel"
                    :navigationPrevLabel="prevLabel">


            <slide v-for="image in vehicle.images" class="slide" :key="image">
              <figure>
                <a :href="url + '/' + vehicle.id + '/' + vehicle.slug + queryString">
                  <img :src="image" :alt="vehicle.modelDescription">
                </a>
              </figure>
            </slide>

          </carousel>


        </div>


        <div class="content vehicleData">
          <h3>
            <a :href="url + '/' + vehicle.id + '/' + vehicle.slug + queryString">{{ vehicle.make }}
              {{ vehicle.modelDescription }}</a>
            <small>Fahrzeugstandort: <span>{{ vehicle.sellerZip }} {{ vehicle.sellerCity }} </span></small></h3>


          <div class="services">
            <div class="l">
              <b>Leistung</b><br>
              {{ vehicle.power.kw }} kW / {{ vehicle.power.ps }} PS
            </div>
            <div class="l">
              <b>Zustand</b><br>
              {{ vehicle.condition }}
            </div>

            <div class="l">
              <b>Laufleistung</b><br>
              {{ vehicle.mileage }} km
            </div>
            <div class="l" v-if="vehicle.firstRegistration">
              <b>Erstzulassung</b><br>
              {{ vehicle.firstRegistration }}
            </div>
          </div>

          <p>

            <template v-if="vehicle.gearbox">{{ vehicle.gearbox }}</template>
            <template v-if="vehicle.consumptionCombined">
              / {{ vehicle.consumptionCombined }} l/100 km&nbsp;(Kraftstoffverbrauch kombiniert),
              {{ vehicle.consumptionInner }} l/100 km&nbsp;(Kraftstoffverbrauch innerorts),
              {{ vehicle.consumptionOuter }} l/100 km&nbsp;(Kraftstoffverbrauch außerorts)
            </template>
            <template v-if="vehicle.co2"> / {{ vehicle.co2 }} g/km&nbsp;(CO₂-Emissionen)</template>

            <template v-if="vehicle.energyEfficiencyClass"> / {{ vehicle.energyEfficiencyClass }}
              (Energieeffizienzklasse)
            </template>


          </p>
          <div class="price__show__more">
            <div class="price">


              <div class="price-group">

                <div v-if="vehicle.uvp" class="discount"><span>Sie sparen {{ vehicle.uvp }} €</span></div>
                <span class="pricing">{{ vehicle.consumerPrice }} €</span>
                <span class="vat" v-if="vehicle.consumerPriceNet"> inkl. {{ vehicle.vatRate }}% MwSt.</span>
                <span v-else class="vat">MwSt. nicht ausweisbar</span>
              </div>


              <div class="price-group finance" v-if="vehicle.financing.has">

                <span class="financing">{{ vehicle.financing.rate }} €</span>

                <span class="vat" v-if="vehicle.financing && vehicle.financing.mwst">Leasingrate netto</span>
                <span class="vat" v-if="vehicle.financing && !vehicle.financing.mwst">Leasingrate brutto</span>

              </div>
            </div>
            <div class="showMore">

          <span v-if="vehicle.abo && vehicle.abo.packages" class="rentThisCar button button__rounded button__primary"
                @click="showRentalInfo(vehicle.abo.id)">
            im <b>Abo</b> ab <b>{{ vehicle.abo.priceFrom }} €</b>
          </span>

              <a :href="url + '/' + vehicle.id + '/' + vehicle.slug + queryString"
                 class="button button__rounded button__dark">Zum Fahrzeug</a></div>
          </div>
        </div>
        <div class="rent-modal rentalInfo" v-if="vehicle.abo  && rentalInfos.includes(vehicle.abo.id)">
          <div class="rent-close" @click="hideRentalInfo(vehicle.abo.id)">+</div>
          <div class="rent-heading">{{ vehicle.abo.name }}</div>
          <div class="rent-content">

            <div class="rent-package" v-for="(pkg, index) in vehicle.abo.packages" :key="index">
              <h3>{{ pkg.name }}</h3>
              <p class="rent_km">{{ pkg.packagedKmLimit }} km<br>pro Monat</p>
              <p class="rent_price"><small>Preis</small><br>
                {{ pkg.price.toLocaleString(undefined, {minimumFractionDigits: 2}) }} €</p>
              <p><a class="button"
                    :href="pkg.url"
                    target="_blank">Zum Angebot »</a></p>
            </div>

          </div>
        </div>

      </div>
      <div v-if="index % 3 === 2 && banner" class="vehicle-banner">
        <a :href="banner.href" target="_blank"><img :src="banner.src"/></a>
      </div>
    </div>
    <div class="button__group t__center mt__60" v-if="vehicles.pagination && vehicles.pagination.next">
      <button type="button" :class="{ loading: loading }" class="button button__rounded button__primary"
              @click="loadMoreVehicles('https://www.schneidergruppe.de/api/vehicles/search' + vehicles.pagination.next)">
        Mehr Fahrzeuge laden
      </button>
    </div>
  </div>
  <div id="no-results-found" v-else-if="vehicles.count === 0">

    <h3>Bitte ändern Sie Ihre Sucheinstellungen.</h3>
    <p> Wir konnten leider keine Fahrzeuge für Ihre Suche finden.</p>
  </div>
  <div id="no-results-found" v-else>

    <h3>Fahrzeuge werden geladen...</h3>
  </div>
</template>

<script>
import {Carousel, Slide} from "vue-carousel/src";
import axios from "axios";


export default {
  name: "Vehicle",

  components: {

    'carousel': Carousel,
    'slide': Slide
  },
  props: {
    vehiclesArr: {
      type: Object
    },
    banner: {
      type: Object
    },
    hasAction: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loaded: false,
      errored: false,
      rentalInfos: [],
      loading: false,
      nextLabel: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M16 12l-6 6V6z"/></svg>',
      prevLabel: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M8 12l6-6v12z"/></svg>',
      rent: {},
      url: '/fahrzeugdetail'
    }
  },
  methods: {
    showRentalInfo(id) {
      if (this.rentalInfos.includes(id) === false) this.rentalInfos.push(id);
    },
    hideRentalInfo(id) {

      this.rentalInfos = this.rentalInfos.filter(function (value) {

        return value !== id
      })

    },
    loadMoreVehicles(url) {
      const _this4 = this;

      this.loading = true;
      axios.get(url).then(function (response) {

        _this4.$store.appendVehicles(response.data)

        _this4.loading = false;
      })["catch"](function (error) {
        return console.log(error);
      })["finally"](function () {
        return _this4.loaded = true;
      });


    }
  },
  computed: {
    vehicles() {
      return this.vehiclesArr;
    },
    queryString() {

      let index = 0;
      const formData = new FormData(this.$refs['v-search']);
      let data = {};
      for (let [key, val] of formData.entries()) {

        if (val !== "") {
          key = key.replace("[]", "[" + index + "]")
          Object.assign(data, {
            [key]: val
          });
          index++;
        }


      }

      const queryString = Object.keys(data).map(function (key) {
        return key + '=' + data[key];
      }).join('&');

      return '?' + queryString;
    }
  }

}
</script>

<style scoped>

</style>
